import { EntityProfileIndustry, EntityProfileType } from "@common/types/entity";
import { FLAT_RATE_PLANS } from "@common/flatRateBilling";
import {
    organizationClientPlans,
    RESTRICTED_ORGANIZATION_CLIENT_PLANS,
} from "@common/constants/organization-billing";
import type { ApplyCloseTemplateEntitySelectionRow } from "./applyCloseTemplateEntitySelection.types";

export const ALL_INDUSTRIES = Object.values(EntityProfileIndustry);
export const ALL_LEGAL_TYPES = Object.values(EntityProfileType);
/** Standard org client plans plus restricted plans. ENTERPRISE and FRESHBOOKS stay hidden. */
export const ALL_PLANS: FLAT_RATE_PLANS[] = [
    ...organizationClientPlans,
    ...RESTRICTED_ORGANIZATION_CLIENT_PLANS,
];

interface EntityFilterParams {
    lowerSearch: string;
    selectedIndustries: EntityProfileIndustry[];
    selectedLegalTypes: EntityProfileType[];
}

interface WorkspaceFilterParams {
    selectedPlans: FLAT_RATE_PLANS[];
}

export function workspaceMatchesFilters(
    workspaceRow: ApplyCloseTemplateEntitySelectionRow,
    params: WorkspaceFilterParams,
): boolean {
    const { selectedPlans } = params;
    return (
        selectedPlans.length === 0 ||
        (workspaceRow.plan != null && selectedPlans.includes(workspaceRow.plan))
    );
}

export function entityMatchesFilters(
    entity: ApplyCloseTemplateEntitySelectionRow,
    clientName: string,
    params: EntityFilterParams,
): boolean {
    const { lowerSearch, selectedIndustries, selectedLegalTypes } = params;
    if (
        lowerSearch &&
        !entity.name.toLowerCase().includes(lowerSearch) &&
        !clientName.toLowerCase().includes(lowerSearch)
    ) {
        return false;
    }
    if (
        selectedIndustries.length > 0 &&
        !entity.industries.some((ind) => selectedIndustries.includes(ind))
    ) {
        return false;
    }
    if (
        selectedLegalTypes.length > 0 &&
        (entity.legalType === null ||
            !selectedLegalTypes.includes(entity.legalType))
    ) {
        return false;
    }
    return true;
}
